import { useState } from 'react';
import { Eye } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MediaSpoilerProps {
  children: React.ReactNode;
  isRevealed?: boolean;
  onReveal?: () => void;
  className?: string;
}

/**
 * Компонент для отображения спойлера на медиа
 * Скрывает контент размытием до клика
 */
export function MediaSpoiler({ children, isRevealed: controlledRevealed, onReveal, className }: MediaSpoilerProps) {
  const [internalRevealed, setInternalRevealed] = useState(false);

  // Support both controlled and uncontrolled modes
  const isRevealed = controlledRevealed !== undefined ? controlledRevealed : internalRevealed;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isRevealed) {
      setInternalRevealed(true);
      onReveal?.();
    }
  };

  return (
    <div className={cn('relative overflow-hidden', className)}>
      {/* Content */}
      <div
        className={cn(
          'transition-all duration-300',
          !isRevealed && 'blur-xl scale-110'
        )}
      >
        {children}
      </div>

      {/* Spoiler overlay */}
      {!isRevealed && (
        <div
          onClick={handleClick}
          className="absolute inset-0 flex items-center justify-center cursor-pointer bg-black/30 transition-opacity hover:bg-black/40"
        >
          <div className="flex flex-col items-center gap-2 text-white">
            <div className="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center">
              <Eye className="h-6 w-6" />
            </div>
            <span className="text-sm font-medium drop-shadow">Нажмите для просмотра</span>
          </div>
        </div>
      )}
    </div>
  );
}
